import Layout from "@/components/feature/Layout";
import BreadcrumbNav from "@/components/base/BreadcrumbNav";
import { aboutContent } from "@/mocks/articleData";

export default function AboutPage() {
  return (
    <Layout>
      <div className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="mb-6">
            <BreadcrumbNav
              items={[
                { label: "首页", path: "/" },
                { label: "关于我们" },
              ]}
            />
          </div>

          <section className="mb-16">
            <div className="max-w-3xl">
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 font-heading mb-4">
                关于{aboutContent.brandName}
              </h1>
              <p className="text-foreground-600 leading-relaxed mb-4">{aboutContent.brandIntro}</p>
              <p className="text-foreground-600 leading-relaxed">{aboutContent.mission}</p>
            </div>
          </section>

          <section className="mb-16">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-5 mb-12">
              {aboutContent.stats.map((stat, index) => (
                <div
                  key={index}
                  className="text-center p-6 rounded-2xl bg-primary-100"
                >
                  <p className="text-2xl md:text-3xl font-bold text-primary-600 font-heading">
                    {stat.value}
                  </p>
                  <p className="text-sm text-foreground-600 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-16">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-2">
              我们的价值观
            </h2>
            <p className="text-foreground-600 mb-8 text-sm">{aboutContent.vision}</p>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {aboutContent.values.map((v, index) => (
                <div
                  key={index}
                  className="p-6 rounded-2xl bg-background-100"
                >
                  <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4">
                    <span className="text-lg font-bold font-heading">{index + 1}</span>
                  </span>
                  <h3 className="font-semibold text-foreground-900 mb-2">{v.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{v.description}</p>
                </div>
              ))}
            </div>
          </section>

          <section>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-8">
              联系我们
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div className="p-6 rounded-2xl bg-background-100 flex items-start gap-4">
                <span className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600">
                  <i className="ri-time-line text-lg"></i>
                </span>
                <div>
                  <h3 className="font-semibold text-foreground-900 mb-1">工作时间</h3>
                  <p className="text-sm text-foreground-600">{aboutContent.contact.workingHours}</p>
                </div>
              </div>

              <div className="p-6 rounded-2xl bg-background-100 flex items-start gap-4">
                <span className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600">
                  <i className="ri-message-3-line text-lg"></i>
                </span>
                <div>
                  <h3 className="font-semibold text-foreground-900 mb-1">响应时间</h3>
                  <p className="text-sm text-foreground-600">{aboutContent.contact.responseTime}</p>
                </div>
              </div>
            </div>

            <div className="mt-8 p-6 rounded-2xl bg-background-100 text-center">
              <p className="text-foreground-600 text-sm mb-4">
                如果您有任何问题或建议，欢迎通过以下方式联系我们
              </p>
              <a
                href="mailto:contact@aiqingdao.com"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line"></i>
                发送邮件联系我们
              </a>
            </div>
          </section>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: `关于${aboutContent.brandName}`,
            description: aboutContent.brandIntro,
            url: "https://aiqingdao.com/about",
            breadcrumb: {
              "@type": "BreadcrumbList",
              itemListElement: [
                { "@type": "ListItem", position: 1, name: "首页", item: "https://aiqingdao.com" },
                { "@type": "ListItem", position: 2, name: "关于我们" },
              ],
            },
          }),
        }}
      />
    </Layout>
  );
}